<template>
  <LayoutDefault
    isShowFooter
    :dateCreated="formaterDate(formData?.DateCreated)"
    :datePublish="formaterDate(formData?.PublicationDate)"
    @storyChange="showStoryChangeModal"
    @saveForm="onSaveProduct"
    @publishForm="onTogglePublished"
    @removePublishForm="onTogglePublished"
    :publishDisabled="!canPublish"
    :isPublished="formData?.Published"
    :saveDisabled="!canSave || isSaving"
    :saveLoading="isSaving"
  >
    <FormConstructor
      @modal-switch="onModalSwitch"
      @openTagsModal="showTags"
      @openKeywordsModal="showKeywords"
      @edit-block="onEditBlock"
      @story-modal="showStoryChangeModal"
      @goBack="closeEditor"
      @update-validity="updateFormValidity"
      @update-publish-status="updatePublishStatus"
      :save-btn-loader="isSaving"
      :policies="cutPolicies(policies, 'Products')"
      cascade-select
      content-blocks
      block-adder
      story-change
      :formDataId="activityId"
      >
      <div class="tags">
        <h2 class="tags-title">Теги внутренней навигации:</h2>
        <TagBox
          header="Добавьте тег внутренней навигации"
          text-btn="Добавить новый тег"
          type-tag="inner"
          @openModal="showTags"
          :itemsArr="tags"
          :categoryId="activityId"
        />
        <div class="tags__btn">
          <BaseBtnNew
          name="Добавить тег"
          @clickBtn="showTags"
        >
          <addTagIcon/>
        </BaseBtnNew>

        <BaseBtnNew
            name="Очистить"
            :disabled="tags?.length === 0"
            @clickBtn="clearTags"
          >
          <clearIcon/>
          </BaseBtnNew>

        </div>
      </div>
      </FormConstructor>

    <TransitionGroup name="bounce">

      <BaseModalWindow
        v-show="modalState.Image"
        @close-modal="onModalSwitch"
        title="Добавление фотографий"
      >
        <ImageUploader
          ref="imageUploaderRef"
          for-content-blocks
          @close-modal="onModalSwitch"
        />
      </BaseModalWindow>

      <BaseModalWindow
        v-if="modalState.Story"
        @close-modal="onModalSwitch"
        type-version="fromEditor"
        title="История изменений"
      >
        <StoryChangeModal
          :selected-default-id="formData.Id"
          :data-table="changeHistoryData"
          @select-version="onSelectHystoryItem"
          @close-modal="onModalSwitch"
        />
      </BaseModalWindow>

      <BaseModalWindow
        v-else-if="modalState.Video"
        @close-modal="onModalSwitch"
        title="Добавление видео"
      >
        <VideoUploader
          @close-modal="onModalSwitch"
          @save-video="addVideoToContentBlock"
        />
      </BaseModalWindow>

      <BaseModalWindow
        v-if="tagsModalVisible"
        @close-modal="closeTagsModal"
        title="Теги навигации"
      >
        <TagsModalNew :categoryId="activityId"/>
      </BaseModalWindow>

      <BaseModalWindow
        v-if="keywordsModalVisible"
        @close-modal="closeKeywordsModal"
        title="Поисковые ключевые слова"
      >
        <KeywordsModal :categoryId="activityId"/>
      </BaseModalWindow>

    </TransitionGroup>

  </LayoutDefault>
</template>

<script>
import { computed, ref, onBeforeMount, watch } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'
import { useRoute } from 'vue-router'
import { formaterDate } from '@/helpers/helpFunctions.js'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import FormConstructor from '@/components/blocks/FormConstructor.vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'
import ImageUploader from '@/components/modals/ImageUploader.vue'
import StoryChangeModal from '@/components/modals/StoryChangeModal.vue'
import VideoUploader from '@/components/modals/VideoUploader.vue'
import TagsModalNew from '@/components/modals/TagsModalNew.vue'
import KeywordsModal from '@/components/modals/KeywordsModal.vue'
import TagBox from '@/components/elements/TagBox.vue'
import BaseBtnNew from '@/components/ui/BaseBtnNew'
import addTagIcon from '@/components/icons/addTagIcon'
import clearIcon from '@/components/icons/clearIcon'

import { cutPolicies } from '@/helpers/policiesValidator.js'
import { useEditorSave } from '@/composables/useEditorSave.js'

export default {
  name: 'EngineeringEditorView',
  components: {
    LayoutDefault,
    FormConstructor,
    BaseModalWindow,
    ImageUploader,
    StoryChangeModal,
    VideoUploader,
    TagsModalNew,
    KeywordsModal,
    TagBox,
    clearIcon,
    BaseBtnNew,
    addTagIcon
  },
  setup () {
    const store = useStore()
    const { isSaving, runSave } = useEditorSave()
    const route = useRoute()

    onBeforeMount(() => {
      // запрос на получение формы редактирования товара
      store.dispatch('setProductForm', `/api/Utilities/GetEngineeringForm/${route.params.id}`)
    })

    const tags = computed(() => store.getters.getShowSelectedTags)

    watch(tags, (newValue) => {
      formData.value.InnerTags = newValue
    })

    const policies = computed(() => store.getters.getPolicies)

    const closeEditor = () => {
      // редирект назад на товары
      router.push('/products/1')
    }

    const formData = computed(() => store.getters.getFormData)
    // объект формы товара (данные которые отобр. в конструкторе)

    const tagsModalVisible = computed(() => store.getters.getShowTagsEditor)

    const keywordsModalVisible = computed(() => store.getters.getShowKeywordsEditor)

    const imageUploaderRef = ref(null) // доступ к экземпляпляру редактора фото

    // ------ методы вызываемые из конструктора (начало) -----
    const onSaveProduct = () => {
      runSave(async () => {
        await store.dispatch('setSaveProduct', `/api/Utilities/PutForm/${formData.value.Id}`)
        await router.push(`/products/EngineeringEditor/${formData.value.Id}`)
        await store.dispatch('setProductForm', `/api/Utilities/GetEngineeringForm/${formData.value.Id}`)
      })
    }

    const onTogglePublished = (publish) => {
      // опубликовать или снять с публикации
      formData.value.Published = publish
      store.dispatch('setToggleProductPublish', {
        url: `/api/Utilities/TooglePublish/${formData.value.Id}`,
        publish
      })
    }

    const onEditBlock = (e) => {
      // ВРЕМЕННОЕ РЕШЕНЕИЕ
      if (e.Type === 'Image') {
        // очищаем данные в компоненте
        imageUploaderRef.value.clearData()
        // добавляет в массив фоток фотографии из контент блока
        imageUploaderRef.value.fotosArr = e.Images
        // делает выбранным изображением первое из контент блока
        imageUploaderRef.value.onSelectImage(e.Images[0], 0)
        // включает спиннер на 2 секунды для плавного рендеринга
        imageUploaderRef.value.spinner = true

        setTimeout(() => {
          imageUploaderRef.value.spinner = false
        }, 2000)
        // открывает модалку
        modalState.value.Image = true
        store.commit('SetEditableImages', e.Images)
      }
    }
    // ------ методы вызываемые из конструктора (конец) -----

    // ------ модалки (начало)------
    const modalState = ref({
      Image: false, // загрузчик фото
      Video: false, // загрузчик видео
      Story: false, // история изменений
      Tags: false // ключ слова и теги
    })

    const onModalSwitch = (modal, val = true) => {
      // modal -- это строка с именем модалки
      // val -- булевое значение
      if (modal === 'all') {
        for (const key in modalState.value) {
          modalState.value[key] = val
        }
      }
      // если вызываем модалку с imageUploader то очищаем предварительно его данные
      if (modal === 'Image' && val) {
        imageUploaderRef.value.clearData()
      }

      modalState.value[modal] = val
    }

    const addVideoToContentBlock = (link) => {
      store.commit('SetAddVideoContentBlock', link)
      store.commit('SetAddContentBlock')
      onModalSwitch('Video', false)
    }

    const changeHistoryData = computed(() => {
      // данные из ьаблички в модалке с историей версий
      return store.getters.getChangeHistoryData
    })

    const showStoryChangeModal = () => {
      // загружаем данные и показываем модалку истории версий
      store.dispatch('setChangeHistory', `/api/Utilities/GetChangeHistory/${formData.value.Id}`)

      onModalSwitch('Story', true)
    }

    const onSelectHystoryItem = (selectedId) => {
      // загружаем версию в первую колонку и открываем страницу истории изменений
      store.dispatch('setFirstColData', `/api/Utilities/GetEngineeringForm/${selectedId}`)
      router.push(`/products/engineeringVersion/${formData.value.Id}`)
    }
    // ------ модалки (конец)------

    const showTags = () => {
      store.dispatch('setTagsDataServices')
      store.commit('SetShowTagsEditor', true)
    }

    const showKeywords = () => {
      store.dispatch('setKeywordsDataServices')
      store.commit('SetShowKeywordsEditor', true)
    }

    const closeTagsModal = () => {
      store.commit('SetShowTagsEditor', false)
      store.dispatch('setClearCacheInnerTagServices')
    }

    const closeKeywordsModal = () => {
      store.commit('SetShowKeywordsEditor', false)
      store.dispatch('setClearCacheInnerKeywordsServices')
    }

    const activityId = 4

    const canSave = ref(false)

    const updateFormValidity = (data) => {
      canSave.value = data.canSave
    }

    const canPublish = ref(false)

    const updatePublishStatus = (data) => {
      canPublish.value = data.canPublish
    }
    const clearTags = () => {
      formData.value.InnerTags = []
      store.dispatch('setClearAllTagUtilites')
    }

    return {
      closeEditor,
      formData,
      formaterDate,
      policies,
      cutPolicies,
      onSaveProduct,
      onTogglePublished,
      modalState,
      onModalSwitch,
      imageUploaderRef,
      onEditBlock,
      addVideoToContentBlock,
      changeHistoryData,
      showStoryChangeModal,
      onSelectHystoryItem,
      isSaving,
      tagsModalVisible,
      keywordsModalVisible,
      showTags,
      showKeywords,
      closeTagsModal,
      closeKeywordsModal,
      activityId,
      updatePublishStatus,
      updateFormValidity,
      canSave,
      canPublish,
      clearTags,
      tags
    }
  }
}
</script>

<style lang="scss" scoped>

.constructor-content {

  &__item, .content-item {
    padding: 10px 0;

    &__header {
      background-color: #1ba6da;
      color: #FFFFFF;
      padding: 5px;
      font-size: 22px;
    }
  }
}

.tags {
  &-title {
    font-weight: 500;
    font-size: 18px;
    text-align: left;
    margin-bottom: 8px;
  }

  &__btn {
    margin-top: 8px;
    display: flex;
    gap: 12px;
  }
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

</style>
